import { createSlice } from "@reduxjs/toolkit";
import { fetchArticleAction, fetchArticleActionTableColumnNames, deleteArticleAction, updateJsonField, updateJsonStatus } from "../thunks";

const initialState = {
  documents: [],
  tableColumnNames: [],
  page: 1,
  perPage: 10,
  totalRecords: 0,
  loading: false,
  error: null
};

const ArticleActionSlice = createSlice({
  name: "ArticleAction",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
      state.page = 1; // ✅ Reset page on perPage change
    },
    updateArticleAction: (state, action) => {
      const { ID, ArticleNumber, ArticleActions, Json } = action.payload;

      state.documents = state.documents.map((item) =>
        item.ID === ID
          ? {
              ...item,
              Json,
              ArticleAction: item.ArticleAction.map((article) => ({
                ...article,
                Json,
                ActionJSON: article.ActionJSON.map((a) =>
                  a.ArticleNumber === ArticleNumber
                    ? {
                        ...a,
                        article_actions: ArticleActions,
                      }
                    : a
                ),
              })),
            }
          : item
      );
    },
    clearArticleAction: (state) => {
      state.documents = []
    }
  },
  extraReducers: (builder) => {
    builder

    .addCase(fetchArticleAction.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchArticleAction.fulfilled, (state, action) => {
      state.loading = false;
      state.documents = action.payload.data;
      state.totalRecords = action.payload.totalRecords;
    })
    .addCase(fetchArticleAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    .addCase(fetchArticleActionTableColumnNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchArticleActionTableColumnNames.fulfilled, (state, action) => {
      state.loading = false;
      state.tableColumnNames = action.payload;
    })
    .addCase(fetchArticleActionTableColumnNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    .addCase(deleteArticleAction.fulfilled, (state, action) => {
      state.loading = false;
      state.documents = action.payload.data;
      state.totalRecords = action.payload.totalRecords;
    })
    .addCase(deleteArticleAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    .addCase(updateJsonField.pending, (state) => {
      state.error = null;
    })
    .addCase(updateJsonField.fulfilled, (state, action) => {
      const {
        ID,
        ActionJSON,
        ArticleActionUpdated,
      } = action.payload;

      state.documents = state.documents.map((item) =>
        item.ID === ID
          ? {
              ...item,
              ActionJSON,
              ArticleActionUpdated,
              ArticleAction: item.ArticleAction.map((article) => ({
                ...article,
                ActionJSON,
                ArticleActionUpdated,
                article_actions: ActionJSON.find((a) => article.ArticleNumber == a.article_number)?.detected_actions_in_text || article.article_actions,
              }))
            }
          : item
      );
    })
    .addCase(updateJsonField.rejected, (state, action) => {
      state.error = action.payload;
    })

    .addCase(updateJsonStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(updateJsonStatus.fulfilled, (state, action) => {
      state.documents = state.documents.map((item) =>
        item.ID == action.payload.ID
          ? {
              ...item,
              ActionJSONStatus: action.payload.ActionJSONStatus,
              ArticleActionUpdated: action.payload.ArticleActionUpdated,
              ArticleAction: item.ArticleAction.map((article) => ({
                ...article,
                ActionJSONStatus: action.payload.ActionJSONStatus,
                ArticleActionUpdated: action.payload.ArticleActionUpdated
              })),
            }
          : item
      );
    })
    .addCase(updateJsonStatus.rejected, (state, action) => {
      state.error = action.payload;
    })
  },
});

export const { setPage, setPerPage, updateArticleAction, clearArticleAction } = ArticleActionSlice.actions;
export default ArticleActionSlice.reducer;